import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { RecaptchaModule } from 'ng-recaptcha';
import { MaterialAngularModule } from './../material-design/material.module';
import { ColaboradorAuthenticationPageComponent } from './colaborador-authentication-page/colaborador-authentication-page.component';
import { ColaboradorAuthenticationFormComponent } from './colaborador-authentication-form/colaborador-authentication-form.component';
import { UsuarioAuthenticationFormComponent } from './usuario-authentication-form/usuario-authentication-form.component';
import { AppRoutingModule } from '../app-routing.module';
import { SharedDirectivesModule } from '../shared/directives/shared-directives.module';
import { AutorizacaoCertificadoModalComponent } from './colaborador-authentication-page/autorizacao-certificado-modal/autorizacao-certificado-modal.component';
import { LoginPorEtapaComponent } from './login-por-etapa/login-por-etapa.component';
import { StepSenhaComponent } from './login-por-etapa/step-senha/step-senha.component';
import { StepClienteSemCarneComponent } from './login-por-etapa/step-cliente-sem-carne/step-cliente-sem-carne.component';
import { StepPreLoginSenhaComponent } from './login-por-etapa/step-pre-login/step-pre-login.component';
import { MatCommonModule } from '@angular/material/core';
import { LoginPageComponent } from './login-page/login-page.component';
import { HeaderComponent } from './login-page/header/header.component';
import { FeaturesSectionComponent } from './login-page/features-section/features-section.component';
import { LoginFormSectionComponent } from './login-page/login-form-section/login-form-section.component';
import { BenefitsSectionComponent } from './login-page/benefits-section/benefits-section.component';
import { FaqSectionComponent } from './login-page/faq-section/faq-section.component';
import { StepClienteSemCadastroComponent } from './login-por-etapa/step-cliente-sem-cadastro/step-cliente-sem-cadastro.component';
import { FeatureCardComponent } from './login-page/components/feature-card/feature-card.component';

@NgModule({
  imports: [
    CommonModule,
    BrowserModule,
    MaterialAngularModule,
    MatCommonModule,
    FormsModule,
    RecaptchaModule,
    AppRoutingModule,
    SharedDirectivesModule,
  ],
  declarations: [
    ColaboradorAuthenticationPageComponent,
    ColaboradorAuthenticationFormComponent,
    UsuarioAuthenticationFormComponent,
    AutorizacaoCertificadoModalComponent,
    LoginPorEtapaComponent,
    StepSenhaComponent,
    StepClienteSemCarneComponent,
    StepPreLoginSenhaComponent,
    LoginPageComponent,
    HeaderComponent,
    FeaturesSectionComponent,
    LoginFormSectionComponent,
    BenefitsSectionComponent,
    FaqSectionComponent,
    StepClienteSemCadastroComponent,
    FeatureCardComponent,
  ],
  exports: [
    LoginPorEtapaComponent,
  ]
})
export class AutenticacaoModule { }
